// extracted by mini-css-extract-plugin
export default {"root":"Quote__root--U5pik","footer":"Quote__footer--xiP7S","button":"Quote__button--ckGp4","icon":"Quote__icon--qyf7V","right":"Quote__right--cld15","total":"Quote__total--xdE1c"};